// Icon theme configuration for Pink Pixel OS
// Strategies:
//  - single: single user color (uses first color)
//  - palette: rotate through provided colors (deterministic by index)
//  - rainbow: generated on the fly (fallback colors list)
// To add a new theme: push another object to iconThemes array.

export const iconThemes = [
  {
    id: 'pinkPixel',
    name: 'Pink Pixel',
    strategy: 'palette',
    colors: ['#f472b6', '#ec4899', '#db2777', '#be185d', '#9d174d']
  },
  {
    id: 'cloudwerx',
    name: 'Cloudwerx',
    strategy: 'palette',
    colors: ['#38bdf8', '#0ea5e9', '#0284c7', '#0369a1', '#075985']
  },
  {
    id: 'monotone',
    name: 'Monotone',
    strategy: 'single',
    colors: ['#e9ecef', '#adb5bd', '#495057', '#212529', '#000000']
  },
  {
    id: 'neon',
    name: 'Neon',
    strategy: 'palette',
    colors: ['#ff00ff', '#00eaff', '#39ff14', '#fffb00', '#f59e0b', '#ff007f']
  },
  {
    id: 'pastel',
    name: 'Pastel',
    strategy: 'palette',
    colors: ['#FBB7E5', '#F6D4A2', '#F9EDB8', '#9AC5D6', '#bbf7d0']
  },
  {
    id: 'rainbow',
    name: 'Rainbow',
    strategy: 'palette',
    colors: ['#B92923', '#D65711', '#EACC1F', '#44A102', '#38bdf8', '#2626D9', '#db2777', '#63288F']
  },
  {
    id: 'userColor',
    name: 'Custom Color',
    strategy: 'single',
    colors: ['#f472b6'] // placeholder, updated at runtime 
  }
]

export const DEFAULT_ICON_THEME = 'neon'
